import { render, staticRenderFns } from "./StageSidebar.vue?vue&type=template&id=d164a840"
import script from "./StageSidebar.vue?vue&type=script&lang=js"
export * from "./StageSidebar.vue?vue&type=script&lang=js"
import style0 from "./StageSidebar.vue?vue&type=style&index=0&id=d164a840&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports